import React, { useState } from "react";
import { DateInputField } from "../../styles";

const DateInput: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = ({
  value,
  onChange,
  onFocus,
  onBlur,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    if (!value) {
      event.target.value = new Date().toLocaleDateString("en-CA");
      onChange?.(event as unknown as React.ChangeEvent<HTMLInputElement>);
    }
    onFocus?.(event);
  };

  return (
    <DateInputField
      {...props}
      value={value ?? ""}
      type={isFocused || value ? "date" : "text"}
      onChange={onChange}
      onFocus={handleFocus}
      onBlur={(event) => {
        setIsFocused(false);
        onBlur?.(event);
      }}
    />
  );
};

export default DateInput;
